module.exports = __webpack_public_path__ + "public/SiteIcons/bedModalIcon.svg?cfb3dd10";